import { useCallback, useEffect, useRef } from 'react';

import { LanguageStore } from 'app/lang';

// ---

const useBeforeUnloadListener = (activeListener: boolean) => {
  const isLangChanged = useRef(false);

  const beforeUnload = useCallback((event: BeforeUnloadEvent) => {
    if (isLangChanged.current) {
      return;
    }

    event.preventDefault();
    event.returnValue = '';
    isLangChanged.current = false;
  }, [isLangChanged.current]);

  useEffect(() => {
    LanguageStore.getInstance().on('languageChanged', () => {
      // Причина, почему реализованно именно так: https://jira.tennisi.it/browse/SITE-1206
      // Это хак для игнорирования beforeunload. Потому что страница может перезагрузиться из-за смены языка
      // Как только появится нормальная логика по смене языка - нужно будет выпилить эту логику
      isLangChanged.current = true;
    });

    if (activeListener) {
      window.addEventListener('beforeunload', beforeUnload);
    }
    else {
      window.removeEventListener('beforeunload', beforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [activeListener]);
};

export default useBeforeUnloadListener;
